// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"f42e0064","159":"f94393e6","272":"a6f468c9","473":"b152c027","476":"efb73576","544":"50d8b7c8","754":"e9f29d13","963":"4859e7a1","964":"2cdd09d9"}[chunkId] + ".chunk.js";
};